const maxActivationWindowDurationDays = 30
const maxCapacity = 5000

export function getLinkValidationErrors(linkObj) {
  const { activationDateString, expirationDateString, totalCapacity } = linkObj
  const errors = []
  if (!activationDateString) {
    errors.push("Missing 'Link Activation Date'")
  }
  if (!expirationDateString) {
    errors.push("Missing 'Link Expiration Date'")
  }
  if (Number(totalCapacity) <= 0) {
    errors.push("'Total capacity' must be more than zero")
  }
  if (Number(totalCapacity) > maxCapacity) {
    errors.push(`Maximum capacity is ${maxCapacity}`)
  }
  if (
    activationDateString &&
    expirationDateString &&
    isActivationAfterExpiration(activationDateString, expirationDateString)
  ) {
    errors.push("'Expiration Time' must be after 'Activation Time'")
  }
  if (
    activationDateString &&
    expirationDateString &&
    isActivationWindowOverMax(activationDateString, expirationDateString)
  ) {
    errors.push(`Maximum activation window is ${maxActivationWindowDurationDays} days`)
  }
  return errors
}

function isActivationAfterExpiration(activationDateString, expirationDateString) {
  return new Date(activationDateString) > new Date(expirationDateString)
}

export function isActivationWindowOverMax(activationDateString, expirationDateString) {
  const activationTimestamp = new Date(activationDateString).getTime()
  const expirationTimestamp = new Date(expirationDateString).getTime()
  const durationMs = expirationTimestamp - activationTimestamp
  const durationDays = durationMs / 1000 / 60 / 60 / 24
  return durationDays > maxActivationWindowDurationDays
}

export function defaultLicenseDateString() {
  /*
  const currentYear = new Date().getFullYear()
  const beforeJuly = new Date().getMonth() < 6
  let endYear
  if (beforeJuly) {
    endYear = currentYear
  } else {
    endYear = currentYear + 1
  }
  return dateInputValueFromDateObj(new Date(endYear, 5, 30))
  */
  var expiration = new Date() // Now
  expiration.setDate(expiration.getDate() + 30)
  return dateInputValueFromDateObj(expiration)
}

export function localDateTimeStringFromUTCdateTimeString(dateString) {
  let dateObj = new Date(dateString)
  dateObj.setMinutes(dateObj.getMinutes() - dateObj.getTimezoneOffset())
  return dateObj.toISOString().slice(0, 16)
}

export function localDateTimeStringFromNow() {
  let dateObj = new Date()
  dateObj.setMinutes(dateObj.getMinutes() - dateObj.getTimezoneOffset())
  return dateObj.toISOString().slice(0, 16)
}

export function utcDateTimeStringFromLocalDateTimeString(dateString) {
  let dateObj = new Date(dateString)
  return dateObj.toISOString().slice(0, 16)
}

export function dateInputValueFromDateObj(dateObj) {
  let dateString = dateObj.toISOString().split('T')[0]
  return dateString
}

export function dateTimeStringFromDateString(dateString) {
  let dateObj = new Date(dateString)
  return dateObj.toISOString().slice(0, 16)
}
